<template>
  <base-show :fields="fields" :resourceName="resourceName" :pk="pk" :breadcrumbs="breadcrumbs"
             @check-maker="checkMaker">
    <template v-slot:actions.remove>
      <span v-if="authAccountId === pk" />
    </template>
    <template slot="recipes" slot-scope="{ input }">
      <CRow>
        <CCol md="12">
          <CButton color="success" @click="showRecipes = !showRecipes">
          紐付きレシピを表示
          </CButton>
        </CCol>
        <CCol md="12">
          <CCollapse :show="showRecipes">
            <CDataTable
              v-if="showRecipes"
              :items="input"
              :fields="[
                { label: 'システム管理商品ID', key: 'recipe_id', _style:'min-width:80px' },
                { label: 'レシピ名', key: 'name', _style:'min-width:150px;' }
              ]"
              :clickableRows="true"
              @row-clicked="moveToShow"
              :noItemsView='{ noResults: "データが存在しません", noItems: loading ? "読込中" : "データが存在しません" }'

            >
            </CDataTable>
          </CCollapse>
        </CCol>
      </CRow>
    </template>
    <template slot="published_status" slot-scope="{ input }">
      <span >
                  {{input === 1 ? "公開" :　
                      ( input === 2 ? "非公開予約" : (
                            input === 3 ? "公開予約"
                                : "非公開"))}}
                </span>
    </template>
    <template slot="user_plan_only" slot-scope="{ input }">
      <span >{{input === 1 ? "会員限定である" : "会員限定でない" }}
                </span>
    </template>
    <template slot="standards" slot-scope="{ input }">
      <CListGroup>
        <CListGroupItem v-for="(standard, index) in input" :key="'process' + index"
                        style="border: 0;font-weight: bold;padding:0;padding-bottom: 5px;font-size:15px;white-space: pre-wrap">{{standard}}
        </CListGroupItem>
      </CListGroup>
    </template>
    <template slot="allergens" slot-scope="{ input }">
      <CListGroup>
        <CListGroupItem v-for="(allergen, index) in input" :key="'process' + index"
                        style="border: 0;font-weight: bold;padding:0;padding-bottom: 5px;font-size:15px;white-space: pre-wrap">{{allergen}}
        </CListGroupItem>
      </CListGroup>
    </template>
    <template slot="nutrient_facts" slot-scope="{ input }">
      <CListGroup>
        <CListGroupItem v-for="(nutrient_fact, index) in input" :key="'process' + index"
                        style="border: 0;font-weight: bold;padding:0;padding-bottom: 5px;font-size:15px;white-space: pre-wrap">{{nutrient_fact}}
        </CListGroupItem>
      </CListGroup>
    </template>
    <template slot="origins" slot-scope="{ input }">
      <CListGroup>
        <CListGroupItem v-for="(origin, index) in input" :key="'process' + index"
                        style="border: 0;font-weight: bold;padding:0;padding-bottom: 5px;font-size:15px;white-space: pre-wrap">{{origin}}
        </CListGroupItem>
      </CListGroup>
    </template>
  </base-show>
</template>

<script>
export default {
  props: {
    pk: {
      type: String,
      required: true
    }
  },
  data() {
    const vm = this;
    return {
      showRecipes: false,
      resourceName: "products",
      fields: [
        [
          {
            label: "システム管理商品ID",
            name: "product_id"
          },
          {
            label: "提供メーカー",
            name: "maker_id",
            optionType: "common/makers",
            render(value) {
              return vm.optionName("common/makers", value);
            },
            isProvider: true
          },
          {
            label: "商品名",
            name: "name"
          },
          {
            label: "商品名かな",
            name: "name_kana"
          },
          {
            label: "商品ID",
            name: "jan_code"
          },
          {
            label: "商品画像",
            name: "images",
            type: "images",
            long: true
          },
          {
            label: "商品紹介",
            name: "description",
            long: true
          },
          {
            label: "商品カテゴリー（大）",
            name: "large_category_id",
            optionType: "common/product_large_categories",
            render(value) {
              return vm.optionName("common/product_large_categories", value);
            }
          },
          {
            label: "商品カテゴリー（中）",
            name: "medium_category_id",
            optionType: "common/product_medium_categories",
            render(value) {
              return vm.optionName("common/product_medium_categories", value);
            }
          },
          {
            label: "内容量",
            name: "net_content",
            long: true
          },
          {
            label: "容器",
            name: "container",
            long: true
          },
          {
            label: "賞味期限",
            name: "best_before",
          },
          {
            label: "温度帯",
            name: "temperature_zone",
          },
          {
            label: "規格一覧",
            name: "standards",
            type: "custom",
            long: true
          },
          {
            label: "その他情報",
            name: "others",
            long: true
          },
          {
            label: "アレルギー情報",
            name: "allergens",
            type: "custom",
            long: true
          },
          {
            label: "栄養成分",
            name: "nutrient_facts",
            type: "custom",
            long: true
          },
          {
            label: "原料原産地",
            name: "origins",
            type: "custom",
            long: true
          },
          {
            label: "サンプル対応可",
            name: "providing_samples",
            render(value) {
              return value === 1 ? "対応可" : "対応不可";
            },
            long: true
          },
          {
            label: "サンプル出荷単位",
            name: "sample_quantity"
          },
          {
            label: "レビューテンプレートID",
            name: "review_set_id",
            optionType: "common/review_sets",
            render(value) {
              return vm.optionName("common/review_sets", value);
            }
          },
          {
            label: "紐付きレシピ",
            name: "recipes",
            type: "custom",
            long: true
          },
          {
            label: "PV数",
            name: "pv"
          },
          {
            label: "公開ステータス",
            name: "published_status",
            type: "custom"
          },
          {
            label: "有償サンプルフラグ",
            name: "sample_paid",
            render(value) {
              return value === 1 ? "有償" : "無償";
            }
          },
          {
            label: "サンプル価格",
            name: "sample_price",
            render(value) {
              if (value !== "" && value !== null && value !== undefined) {
                return value.toLocaleString() + " 円";
              }
              return "";
            }
          },
          {
            label: "会員限定フラグ",
            name: "user_plan_only",
            type: "custom"
          }
        ]
      ]
    };
  },
  computed: {
    loading() {
      return this.$store.getters[`${this.resourceName}/entity/isLoading`];
    },
    breadcrumbs() {
      return [
        {
          text: "商品管理",
          disabled: false,
          to: `/${this.resourceName}`
        },
        {
          text: "商品詳細",
          disabled: true
        }
      ];
    },
    authAccountId() {
      return this.$store.getters[`auth/accountId`];
    },
    optionName() {
      return (optionName, value) => {
        const options =
          this.$store.getters[`${optionName}/options/options`] || [];
        return (options.find(v => v.value === value) || {}).label;
      };
    }
  },
  methods: {
    moveToUpdatePasswordView() {
      this.$router.push({
        path: `/${this.resourceName}/${this.pk}/edit/password`
      });
    },
    moveToShow(item) {
      this.$router.push({
        path: `/recipes/${item['recipe_id']}`
      });
    },
    checkMaker(entity) {
      this.$router.push({ path: `/makers/${entity.maker_id}` });
    }
  }
};
</script>
